import { getDefaultLogger } from '@kc-console/core';

import { isServerTraceEnabled } from './sampling';

import type { ServerTraceSummary } from './types';

/**
 * 요청 단위 trace를 기존 Console 서버 로그 파이프라인에 구조화된 JSON으로 출력합니다.
 *
 * `getDefaultLogger`가 ECS 형식과 `service_id`를 추가하며, 배포 환경에서는 컨테이너
 * stdout 수집기를 통해 Elasticsearch/Kibana로 전달됩니다. 로컬 release에서는 기존
 * 로거 정책에 따라 noop 처리됩니다.
 */
export const logServerTrace = (summary: ServerTraceSummary) => {
  if (!isServerTraceEnabled()) return;

  const logger = getDefaultLogger({
    type: 'server_performance',
    url: summary.normalizedRoute,
    custom: {
      server_performance: summary,
    },
  });

  logger.info('SERVER PERFORMANCE');
};
